export default __webpack_public_path__ + "static/media/bob-mastery-test-fail.a9997b35.png";